import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _invert from "lodash/invert";

var _actionSearchTypesNam, _actionSearchTypesCol, _actionStatusName, _actionStatusColorMap, _actionEventTypeName, _actionEventTypeColor;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var ACTION_ACTION_TYPE = {
  comment: 'comment',
  arrangement: 'arrangement',
  call: 'call',
  visit: 'visit'
};
export var actionSearchTypesName = (_actionSearchTypesNam = {}, _defineProperty(_actionSearchTypesNam, ACTION_ACTION_TYPE.comment, 'Коментар'), _defineProperty(_actionSearchTypesNam, ACTION_ACTION_TYPE.arrangement, 'Уговорка'), _defineProperty(_actionSearchTypesNam, ACTION_ACTION_TYPE.call, 'Обаждане'), _defineProperty(_actionSearchTypesNam, ACTION_ACTION_TYPE.visit, 'Посещение'), _actionSearchTypesNam);
export var actionSearchTypesColorMap = (_actionSearchTypesCol = {}, _defineProperty(_actionSearchTypesCol, ACTION_ACTION_TYPE.comment, 'orange'), _defineProperty(_actionSearchTypesCol, ACTION_ACTION_TYPE.arrangement, 'info'), _defineProperty(_actionSearchTypesCol, ACTION_ACTION_TYPE.call, 'green'), _defineProperty(_actionSearchTypesCol, ACTION_ACTION_TYPE.visit, 'warning'), _actionSearchTypesCol);
export var actionSearchTypesNameSelect = Object.entries(_invert(actionSearchTypesName)).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      value = _ref2[1];

  return {
    label: label,
    value: value
  };
});
export var ACTION_STATUS = {
  active: 'active',
  completed: 'completed',
  snoozed: 'snoozed'
};
export var actionStatusName = (_actionStatusName = {}, _defineProperty(_actionStatusName, ACTION_STATUS.active, 'Активен'), _defineProperty(_actionStatusName, ACTION_STATUS.completed, 'Завършен'), _defineProperty(_actionStatusName, ACTION_STATUS.snoozed, 'Отложен'), _actionStatusName);
export var actionStatusColorMap = (_actionStatusColorMap = {}, _defineProperty(_actionStatusColorMap, ACTION_STATUS.active, 'blue'), _defineProperty(_actionStatusColorMap, ACTION_STATUS.completed, 'green'), _defineProperty(_actionStatusColorMap, ACTION_STATUS.snoozed, 'warning'), _actionStatusColorMap);
export var actionStatusFilterOptions = [{
  label: 'Активен',
  value: ACTION_STATUS.active
}, {
  label: 'Завършен',
  value: ACTION_STATUS.completed
}, {
  label: 'Отложен',
  value: ACTION_STATUS.snoozed
}];
export var ACTION_EVENT_TYPE = {
  created: 'created',
  updated: 'updated',
  completed: 'completed',
  snoozed: 'snoozed',
  reopened: 'reopened'
};
export var actionEventTypeName = (_actionEventTypeName = {}, _defineProperty(_actionEventTypeName, ACTION_EVENT_TYPE.created, 'Създадено'), _defineProperty(_actionEventTypeName, ACTION_EVENT_TYPE.updated, 'Редактирано'), _defineProperty(_actionEventTypeName, ACTION_EVENT_TYPE.completed, 'Завършено'), _defineProperty(_actionEventTypeName, ACTION_EVENT_TYPE.snoozed, 'Отложено'), _defineProperty(_actionEventTypeName, ACTION_EVENT_TYPE.reopened, 'Отворено отново'), _actionEventTypeName);
export var actionEventTypeColorMap = (_actionEventTypeColor = {}, _defineProperty(_actionEventTypeColor, ACTION_EVENT_TYPE.created, 'blue'), _defineProperty(_actionEventTypeColor, ACTION_EVENT_TYPE.updated, 'info'), _defineProperty(_actionEventTypeColor, ACTION_EVENT_TYPE.completed, 'green'), _defineProperty(_actionEventTypeColor, ACTION_EVENT_TYPE.snoozed, 'warning'), _defineProperty(_actionEventTypeColor, ACTION_EVENT_TYPE.reopened, 'orange'), _actionEventTypeColor);